<template>
  <swiper :options="swiperOption" ref="carouselLogos">
    <swiper-slide v-for="(logo, index) in getLogos()" :key="index" class="py-2">
      <div class="border-left border-right d-flex align-items-center justify-content-center h-100">
        <img :key="index" :src="logo" class="mw-100" />
      </div>
    </swiper-slide>
    <div class="swiper-button-prev swiper-button-grey" slot="button-prev"></div>
    <div class="swiper-button-next swiper-button-grey" slot="button-next"></div>
  </swiper>
</template>


<script>
export default {
  name: "the-footer-logos",
  data() {
    return {
      swiper: { },
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        breakpointsInverse: true,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 3,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 4,
          },
          // when window width is >= 667px
          667: {
            slidesPerView: 5,
          },
          // when window width is >= 768px
          768: {
            slidesPerView: 6,
          },
        },
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
      },
    };
  },
  mounted() {
    this.swiper = this.$refs.carouselLogos.swiper;
    this.swiper.on("observerUpdate", function() {
      this.update();
    });
  },
  methods: {
    getLogos: function(){
      var logos = []
      const req = require.context('@/static/footer/', true, /\.(png|jpg)$/i);
      req.keys().map(key => {
        logos.push(req(key))
      });
      return logos;
    },
  },
};
</script>


<style lang="scss" scoped>
.swiper-button-next,
.swiper-button-prev {
  height: 20px;
  margin-top: -10px;
}
.swiper-button-prev.swiper-button-grey,
.swiper-container-rtl .swiper-button-next.swiper-button-grey {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23efeeee'%2F%3E%3C%2Fsvg%3E");
}
.swiper-button-next.swiper-button-grey,
.swiper-container-rtl .swiper-button-prev.swiper-button-grey {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23efeeee'%2F%3E%3C%2Fsvg%3E");
}
</style>
